import { useEffect, useState } from "react";
import DataTable from "../../component/DataTable";
import { Link } from "react-router-dom";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints"; 
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const dynamicDeleteEndpoint = ApiEndpoints.dynamic.dynamicDelete;
const dynamicListEndpoint = ApiEndpoints.dynamic.dynamicList;
const dynamicEditPath = "edit-dynamic";
const tableHeader = ["Date","Title","Slug"];
const tbody = ["date","title","slug"];

export default function DynamicListing() {

  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", dynamicListEndpoint);
      const result = response.pages;
      setData(result);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => { 
    dataFetch();
  }, []);

  const handleDelete = async (page_id) => {
      const payload = { page_id };
      try {
        const response = await ApiRequest("POST", dynamicDeleteEndpoint, payload);
        toast.success(response.message)
        dataFetch();
      } catch (error) {
        console.error(error);
      }
    };

    const pagename = {
      name: 'Dynamic Page',
      user: 'Admin',
      innerpage: 'Dynamic Page / pages'
    }

  return (
    <>
    <AdminHeader pagename={pagename}/>

      <div className="add-btn-section">
        <Link className="admin-add-btn" to="/add-dynamic">Add +</Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={dynamicEditPath}
          onDelete={handleDelete}
        />
      </div>
    </>
  );
}
